import { BANK_ACCOUNT_MAX_LENGTH } from "utils/constants";

export const bankAccountValidation = (value: string): boolean => {
  return value.replaceAll("-", "").length === BANK_ACCOUNT_MAX_LENGTH;
};
